import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import CanalSelect from "./CanalSelect.js"
import DetailEmpresas from "../../clientes/Empresas/Detail.js"

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            departamento_id: null,
            departamentopadre_id: null,
            empresa_id: null,
            canal_id: null,
            ltp_id: null,
            lte_id: null,

            impacta_pais: "",
            impacta_provincia: "",
            impacta_ciudad: "",
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            departamento_id: null,
            departamentopadre_id: null,
            empresa_id: null,
            canal_id: null,
            ltp_id: null,
            lte_id: null,

            impacta_pais: "",
            impacta_provincia: "",
            impacta_ciudad: "",
        })
    }

    setSelects(data) {
        this.setState({
            departamento_id: data.departamentointerno_id,
            departamentopadre_id: data.departamentointernopadre_id,
            empresa_id: data.empresa_id,
            canal_id: data.canal_id,
            ltp_id: data.ltp_id,
            lte_id: data.lte_id,

            impacta_pais: data.impacta_pais || " ",
            impacta_provincia: data.impacta_provincia,
            impacta_ciudad: data.impacta_ciudad,
        });
    }

    render() {
        const {
            impacta_pais,
            impacta_provincia,
            impacta_ciudad,
        } = this.state

        return (
            <ParadigmaModal
                getUrl={api.proyectos.solicitudes.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Solicitud"}
                buttonTitle={"Ver Solicitud"}
                buttonIcon={"fa fa-search fa-lg"}
                className={"ui-modal-dialog ui-modal-lg"}

                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >
                <div className="ui-form">
                    <div className="ui-section-grid">
                        <section className="ui-section-block">
                            <p className="ui-section-label">Identificación</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Grupo</Label>
                                    <ParadigmaAsyncSeeker
                                        disabled={true}
                                        fieldName={""}
                                        url={api.usuarios.grupos.select}
                                        value={this.state.departamentopadre_id}
                                    />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Subgrupo</Label>
                                    <ParadigmaAsyncSeeker
                                        disabled={true}
                                        fieldName={"departamentointerno_id"}
                                        url={api.usuarios.subgrupos.select}
                                        value={this.state.departamento_id}
                                    />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Código</Label>
                                    <Input 
                                        disabled={true} 
                                        style={{ backgroundColor: "#c1c1c1", color: "#4b4b4b"}} 
                                        type="text" name={"codigo"} 
                                    />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Datos principales</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Título</Label>
                                    <Input disabled={true} type="text" name={"nombre"} />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Forma de Contacto</Label>
                                    <CanalSelect value={this.state.canal_id} disabled={true} />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Empresa/Organización</Label>
                                    <ParadigmaAsyncSeeker
                                        Detail={DetailEmpresas}
                                        fieldName={"empresa_id"}
                                        url={api.clientes.empresas.select}
                                        value={this.state.empresa_id}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Localización donde impacta el proyecto</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>País</Label>
                                    <Input disabled={true} type="text" name={"impacta_pais"} value={impacta_pais} />
                                </div>
                            </div>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Provincia</Label>
                                    <Input disabled={true} type="text" name={"impacta_provincia"} value={impacta_provincia} />
                                </div>
                                <div className="ui-field">
                                    <Label>Ciudad</Label>
                                    <Input disabled={true} type="text" name={"impacta_ciudad"} value={impacta_ciudad} />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block ui-section-compact">
                            <p className="ui-section-label">Observaciones</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Observaciones</Label>
                                    <Input disabled={true} type="textarea" rows={5} name={"observaciones"} />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block ui-section-span-2">
                            <p className="ui-section-label">Responsables</p>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Líder Técnico Proyecto</Label>
                                    <ParadigmaAsyncSeeker
                                        fieldName={"ltp_id"}
                                        disabled={true}
                                        url={api.usuarios.usuarios.select}
                                        value={this.state.ltp_id}
                                    />
                                </div>
                                {this.state.empresa_id &&
                                    <div className="ui-field">
                                        <Label>Líder Técnico Empresa</Label>
                                        <ParadigmaAsyncSeeker
                                            disabled={true}
                                            fieldName={"lte_id"}
                                            nombreField={"fullname"}
                                            url={api.clientes.responsables.select + "?tipo=0&empresa_id=" + this.state.empresa_id}
                                            value={this.state.lte_id}
                                        />
                                    </div>
                                }
                            </div>
                        </section>
                    </div>
                </div>

            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento1/Detail.js